<div class="deleteDialog">
	<div class="detailStatus">
		<h2 mat-dialog-title class="mb-0">{{title}}</h2>
		<div class="example-button-row">
	  		<button mat-raised-button class="deleteStatus" (click)="dialogclose(true)">Yes</button>
	    	<button mat-raised-button color="warn" class="ml-2" (click)="dialogclose(false)">No</button>
		</div>
	</div>
</div>